var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 430",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "RAG pipeline diagram") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Sch\xE9ma RAG fid\xE8le au style portfolio"), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "a",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1L8 5L2 9",
    fill: "none",
    stroke: "context-stroke",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "imagine-text-gaps-hnpc2u",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 430,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.70748901367188,
    y: 47.388221740722656,
    width: 37.4019660949707,
    height: 34.223073959350586,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.87095642089844,
    y: 100.66634368896484,
    width: 48.83551788330078,
    height: 18.167065620422363,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.1979675292969,
    y: 100.66634368896484,
    width: 33.81171798706055,
    height: 18.167065620422363,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.6025695800781,
    y: 100.66634368896484,
    width: 59.59755325317383,
    height: 18.167065620422363,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.36996459960938,
    y: 262.6663513183594,
    width: 58.002967834472656,
    height: 18.167065620422363,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.6612243652344,
    y: 262.6663513183594,
    width: 55.25459671020508,
    height: 18.167065620422363,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.71051025390625,
    y: 276.6663513183594,
    width: 69.05480194091797,
    height: 18.167065620422363,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.61810302734375,
    y: 384.66632080078125,
    width: 67.56283950805664,
    height: 18.167065620422363,
    fill: "black",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.55955505371094,
    y: 398.6663513183594,
    width: 33.68110656738281,
    height: 18.167065620422363,
    fill: "black",
    rx: 2
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 420,
    fill: "#021727",
    style: {
      fill: "rgb(2, 23, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 28,
    width: 72,
    height: 72,
    rx: 14,
    fill: "#1a3a5c",
    stroke: "#2a6090",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(26, 58, 92)",
      stroke: "rgb(42, 96, 144)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 73,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 26,
    fontWeight: 700,
    fill: "#7eb8e0",
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "monospace",
      fontSize: 26,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "&gt;_"), /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 114,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 12,
    fill: "#7eb8e0",
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Prompt"), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    y1: 64,
    x2: 278,
    y2: 64,
    stroke: "#7eb8e0",
    strokeWidth: 1.8,
    strokeDasharray: "7,5",
    fill: "none",
    markerEnd: "url(#a)",
    style: {
      fill: "none",
      stroke: "rgb(126, 184, 224)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.8px",
      strokeDasharray: "7px, 5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 28,
    width: 72,
    height: 72,
    rx: 14,
    fill: "#1a3a5c",
    stroke: "#2a6090",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(26, 58, 92)",
      stroke: "rgb(42, 96, 144)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 50,
    r: 4,
    fill: "#7eb8e0",
    opacity: 0.8,
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 64,
    r: 4,
    fill: "#7eb8e0",
    opacity: 0.8,
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 78,
    r: 4,
    fill: "#7eb8e0",
    opacity: 0.8,
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 57,
    r: 4,
    fill: "#c09c4c",
    opacity: 0.9,
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 71,
    r: 4,
    fill: "#c09c4c",
    opacity: 0.9,
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 64,
    r: 4,
    fill: "#7eb8e0",
    opacity: 0.8,
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 50,
    x2: 312,
    y2: 57,
    stroke: "#7eb8e0",
    strokeWidth: 0.9,
    opacity: 0.7,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(126, 184, 224)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.9px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 64,
    x2: 312,
    y2: 57,
    stroke: "#7eb8e0",
    strokeWidth: 0.9,
    opacity: 0.7,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(126, 184, 224)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.9px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 64,
    x2: 312,
    y2: 71,
    stroke: "#7eb8e0",
    strokeWidth: 0.9,
    opacity: 0.7,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(126, 184, 224)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.9px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 78,
    x2: 312,
    y2: 71,
    stroke: "#7eb8e0",
    strokeWidth: 0.9,
    opacity: 0.7,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(126, 184, 224)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.9px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 57,
    x2: 330,
    y2: 64,
    stroke: "#c09c4c",
    strokeWidth: 0.9,
    opacity: 0.8,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.9px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 71,
    x2: 330,
    y2: 64,
    stroke: "#c09c4c",
    strokeWidth: 0.9,
    opacity: 0.8,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "0.9px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 316,
    y: 114,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 12,
    fill: "#7eb8e0",
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "LLM"), /*#__PURE__*/React.createElement("line", {
    x1: 354,
    y1: 64,
    x2: 448,
    y2: 64,
    stroke: "#7eb8e0",
    strokeWidth: 1.8,
    fill: "none",
    markerEnd: "url(#a)",
    style: {
      fill: "none",
      stroke: "rgb(126, 184, 224)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 28,
    width: 72,
    height: 72,
    rx: 14,
    fill: "#1a3a5c",
    stroke: "#2a6090",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(26, 58, 92)",
      stroke: "rgb(42, 96, 144)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 42,
    width: 42,
    height: 30,
    rx: 6,
    fill: "#2a6090",
    opacity: 0.9,
    style: {
      fill: "rgb(42, 96, 144)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469,
    y: 49,
    width: 26,
    height: 4,
    rx: 2,
    fill: "#7eb8e0",
    opacity: 0.9,
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469,
    y: 57,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#7eb8e0",
    opacity: 0.6,
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469,
    y: 65,
    width: 23,
    height: 4,
    rx: 2,
    fill: "#7eb8e0",
    opacity: 0.4,
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 114,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 12,
    fill: "#7eb8e0",
    style: {
      fill: "rgb(126, 184, 224)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Response"), /*#__PURE__*/React.createElement("path", {
    d: "M91 102 Q91 168 192 200",
    stroke: "#c09c4c",
    strokeWidth: 2,
    fill: "none",
    markerEnd: "url(#a)",
    mask: "url(#imagine-text-gaps-hnpc2u)",
    style: {
      fill: "none",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 148,
    width: 608,
    height: 252,
    rx: 16,
    fill: "#0a1f10",
    stroke: "#c09c4c",
    strokeWidth: 1,
    opacity: 0.9,
    style: {
      fill: "rgb(10, 31, 16)",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 178,
    width: 84,
    height: 84,
    rx: 14,
    fill: "#c09c4c",
    stroke: "#e8b860",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "rgb(232, 184, 96)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 211,
    r: 17,
    fill: "none",
    stroke: "#021727",
    strokeWidth: 3.5,
    style: {
      fill: "none",
      stroke: "rgb(2, 23, 39)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "3.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198,
    y1: 223,
    x2: 212,
    y2: 237,
    stroke: "#021727",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(2, 23, 39)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "3.5px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177,
    y1: 206,
    x2: 194,
    y2: 206,
    stroke: "#021727",
    strokeWidth: 2.5,
    opacity: 0.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(2, 23, 39)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179,
    y1: 213,
    x2: 193,
    y2: 213,
    stroke: "#021727",
    strokeWidth: 2.5,
    opacity: 0.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(2, 23, 39)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 276,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 12,
    fill: "#c09c4c",
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Retriever"), /*#__PURE__*/React.createElement("line", {
    x1: 236,
    y1: 220,
    x2: 306,
    y2: 220,
    stroke: "#c09c4c",
    strokeWidth: 1.8,
    fill: "none",
    markerEnd: "url(#a)",
    style: {
      fill: "none",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 178,
    width: 84,
    height: 84,
    rx: 14,
    fill: "#c09c4c",
    stroke: "#e8b860",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "rgb(232, 184, 96)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 196,
    width: 36,
    height: 46,
    rx: 3,
    fill: "#021727",
    opacity: 0.4,
    style: {
      fill: "rgb(2, 23, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 190,
    width: 36,
    height: 46,
    rx: 3,
    fill: "#021727",
    opacity: 0.6,
    style: {
      fill: "rgb(2, 23, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 184,
    width: 36,
    height: 46,
    rx: 3,
    fill: "#021727",
    opacity: 0.85,
    style: {
      fill: "rgb(2, 23, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.85,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343,
    y1: 194,
    x2: 364,
    y2: 194,
    stroke: "#c09c4c",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343,
    y1: 202,
    x2: 364,
    y2: 202,
    stroke: "#c09c4c",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343,
    y1: 210,
    x2: 358,
    y2: 210,
    stroke: "#c09c4c",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 276,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 12,
    fill: "#c09c4c",
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Relevant"), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 290,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 12,
    fill: "#c09c4c",
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Documents"), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 264,
    x2: 200,
    y2: 308,
    stroke: "#c09c4c",
    strokeWidth: 1.8,
    fill: "none",
    markerEnd: "url(#a)",
    mask: "url(#imagine-text-gaps-hnpc2u)",
    style: {
      fill: "none",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 310,
    x2: 190,
    y2: 266,
    stroke: "#c09c4c",
    strokeWidth: 1.8,
    fill: "none",
    markerEnd: "url(#a)",
    mask: "url(#imagine-text-gaps-hnpc2u)",
    style: {
      fill: "none",
      stroke: "rgb(192, 156, 76)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 310,
    width: 84,
    height: 74,
    rx: 14,
    fill: "#c09c4c",
    stroke: "#e8b860",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "rgb(232, 184, 96)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192,
    cy: 330,
    rx: 22,
    ry: 8,
    fill: "#021727",
    opacity: 0.75,
    style: {
      fill: "rgb(2, 23, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.75,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 330,
    width: 44,
    height: 20,
    fill: "#021727",
    opacity: 0.55,
    style: {
      fill: "rgb(2, 23, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.55,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192,
    cy: 350,
    rx: 22,
    ry: 8,
    fill: "#021727",
    opacity: 0.75,
    style: {
      fill: "rgb(2, 23, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.75,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 347,
    width: 44,
    height: 14,
    fill: "#021727",
    opacity: 0.45,
    style: {
      fill: "rgb(2, 23, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.45,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192,
    cy: 361,
    rx: 22,
    ry: 8,
    fill: "#021727",
    opacity: 0.65,
    style: {
      fill: "rgb(2, 23, 39)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.65,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 398,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 12,
    fill: "#c09c4c",
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Knowledge"), /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 412,
    textAnchor: "middle",
    fontFamily: "Georgia,serif",
    fontSize: 12,
    fill: "#c09c4c",
    style: {
      fill: "rgb(192, 156, 76)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Georgia, serif",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Base"), /*#__PURE__*/React.createElement("path", {
    d: "M392 178 Q392 64 356 64",
    stroke: "#80cc80",
    strokeWidth: 1.8,
    fill: "none",
    strokeDasharray: "6,4",
    markerEnd: "url(#a)",
    opacity: 0.8,
    style: {
      fill: "none",
      stroke: "rgb(128, 204, 128)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.8px",
      strokeDasharray: "6px, 4px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRag);
export default __webpack_public_path__ + "static/media/rag.adb4df1a7977a7e8c4c7786a3e10d626.svg";
export { ForwardRef as ReactComponent };